import api, { apiSetup } from '../api';

apiSetup();

export class TiposProyectoService {
  BASE_URL = '/tipos-proyecto';

  get() {
    return api.get(this.BASE_URL);
  }
}
